import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface UpdateAutoLinkingStudiesModalProps {
  studyNames: Array<string>;
  onRequestSubmit: (result: {}) => void;
  onRequestClose: () => void;
}

export default function UpdateAutoLinkingStudiesModal({
  studyNames,
  onRequestSubmit,
  onRequestClose,
}: UpdateAutoLinkingStudiesModalProps): JSX.Element {
  const studyNamesText = studyNames.join(', ');
  return (
    <Modal
      title="Unlink entry from study"
      buttons={[
        {
          text: 'Cancel',
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            onRequestClose();
          },
        },
        {
          text: 'Confirm',
          submit: true,
          style: ButtonStyle.NEGATIVE,
        },
      ]}
      onRequestSubmit={() => {
        onRequestSubmit({});
      }}
      onRequestClose={onRequestClose}
    >
      <p className={css(styles.modalBody)}>
        Any new items created in this entry will no longer be automatically linked to{' '}
        <strong>{studyNamesText}</strong>.
      </p>
      <p className={css(styles.modalBody)}>
        Any previously created items will maintain their existing links to their studies. To modify or unlink
        them, you must edit each item's metadata.
      </p>
      <p className={css(styles.modalBody)}>
        This action is irreversible. You will not be able to re-establish automatic linking for this study
        after removal.
      </p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalBody: {
    fontSize: '14px',
  },
});
